import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

import { Breakpoint } from '@constants/common/ui.constants';

const useStyles = makeStyles()((theme) => ({
  content: {
    display: 'grid',
    gap: 16,
  },
  btns: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: 16,

    [theme.breakpoints.down(Breakpoint.Md)]: {
      marginTop: 'auto',
    },

    [theme.breakpoints.down(Breakpoint.Sm)]: {
      gridTemplateColumns: 'repeat(1, 1fr)',
      gap: 8,
    },
  },
  stats: {
    display: 'grid',
    gap: 8,
  },
  item: {
    background: 'transparent',
    padding: 0,
    flexDirection: 'row',
    width: '100%',
  },
  value: {
    justifyContent: 'end',
  },
  title: {
    textWrap: 'nowrap',
  },
  contentBox: {
    ...dFlex(),
    gap: 4,
    textTransform: 'capitalize',

    img: {
      display: 'flex',
      width: 20,
      height: 20,
      borderRadius: theme.borderRadius.xxl,
    },
  },
  farm: {
    ...dFlex('start'),
    gap: 4,
  },
  childrenBox: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    height: 'inherit',
  },
  loader: {
    height: 16,
    width: 100,
  },
  loaderBox: {
    display: 'flex',
    marginLeft: 'auto',
  },
  warningBox: {
    ...dFlex('start', 'start'),
    gap: 8,
  },
  icon: {
    marginTop: 2,
    fontSize: 18,
    color: theme.accent.a4,
  },
}));

export default useStyles;
